const problemGoalData = [
  {
    problemTitle: "정보 구조의 부재",
    problemDesc: "사용자 기준 흐름 없이 메뉴만 존재",

    goal: "사용자 중심 구조로 전환",
  },
  {
    problemTitle: "콘텐츠 접근성 낮음",
    problemDesc: "연구자료 / 소식 / 참여 기능 분리",

    goal: "연구자료 / 소식 / 참여 기능을 하나의 흐름으로 연결",
  },
  {
    problemTitle: "공공기관 신뢰감 부족",
    problemDesc: "디자인이 단순하고 브랜드 정체성 부족",

    goal: "공공기관에 맞는 신뢰감 있는 시각적 UI 구축",
  },
  {
    problemTitle: "사용자 참여 유도 부족",
    problemDesc: "사용자 행동 흐름이 없음",

    goal: "시민 참여를 유도하는 인터랙션 구조 설계",
  },
];

export default problemGoalData;